import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // relay ไปปลายทาง (Inbox/KOL/Biddable) ช้ากว่า API ของเราเอง
      // ไม่ต้องยิงซ้ำทุกครั้งที่สลับแท็บกลับมา
      refetchOnWindowFocus: false,
      staleTime: 60_000,
      retry: 1,
    },
  },
});
